import React, {ReactNode} from 'react';
import b_ from 'b_';

import {useDropzone, DropzoneOptions, FileRejection} from 'react-dropzone';

export interface FileUploadProps extends DropzoneOptions {
    className?: string;
    children?: ReactNode;
    onChange?: (params: {acceptedFiles: File[]; fileRejections: FileRejection[]}) => void;
}

const b = b_.with('file-upload');

export default function FileUpload(props: FileUploadProps) {
    const {className = '', children, ...dropzoneProps} = props;

    const {getRootProps, getInputProps} = useDropzone(dropzoneProps);

    return (
        <div {...getRootProps({className: `${b()} ${className}`})}>
            <input {...getInputProps()} />
            {children ? children : <p>Drop some files here, or click to select files</p>}
        </div>
    );
}
